var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChangePassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_57",
    "data-name": "Rectangle 57",
    width: 18,
    height: 18,
    transform: "translate(60 171)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_32",
    "data-name": "Mask Group 32",
    transform: "translate(-60 -171)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "__TEMP__SVG__",
    transform: "translate(59.407 170.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M16.194,1.2a2.4,2.4,0,0,0-1.287,4.422L13.341,11.1q-.073,0-.146,0a2.386,2.386,0,0,0-1.432.475L8.871,9.161a2.4,2.4,0,1,0-3.951.949l-1.7,3.4Q3.111,13.5,3,13.5a2.4,2.4,0,1,0,1.359.423l1.6-3.208a2.393,2.393,0,0,0,2.249-.538l2.8,2.334a2.4,2.4,0,1,0,3.472-1.033l1.565-5.479c.048,0,.1,0,.146,0a2.4,2.4,0,1,0,0-4.8ZM3,17.094a1.2,1.2,0,1,1,1.2-1.2A1.2,1.2,0,0,1,3,17.094ZM6.6,9.6A1.2,1.2,0,1,1,7.8,8.4,1.2,1.2,0,0,1,6.6,9.6Zm6.6,5.1a1.2,1.2,0,1,1,1.2-1.2,1.2,1.2,0,0,1-1.2,1.2Zm3-9.9a1.2,1.2,0,1,1,1.2-1.2A1.2,1.2,0,0,1,16.194,4.8Z",
    fill: "#9babc5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangePassword);
export default __webpack_public_path__ + "static/media/change-password.de6fa05d8d6ffece4af84b7b1c855e07.svg";
export { ForwardRef as ReactComponent };